import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Check, Trash2, Ban, RotateCcw } from "lucide-react";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get(`/admin/users${q ? `?q=${q}` : ""}`).then((r) => setUsers(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const suspend = async (id, currently) => {
    try {
      await api.post(`/admin/users/${id}/${currently ? "unsuspend" : "suspend"}`);
      toast.success(currently ? "Unsuspended" : "Suspended");
      load();
    } catch { toast.error("Failed"); }
  };
  const del = async (id) => {
    if (!window.confirm("Delete this user and all their content?")) return;
    try { await api.delete(`/admin/users/${id}`); toast.success("Deleted"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="p-6 lg:p-10">
      <div className="border-b border-border pb-6 mb-8 flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="label-mono text-muted-foreground mb-1">User management</div>
          <h1 className="font-serif text-4xl">Users</h1>
        </div>
        <div className="flex gap-2">
          <Input
            className="rounded-sm bg-background border-border h-11 w-64"
            placeholder="Search by name / mobile / username"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && load()}
            data-testid="admin-users-search"
          />
          <Button onClick={load} className="rounded-sm h-11 label-mono bg-foreground text-background" data-testid="admin-users-search-btn">
            Search
          </Button>
        </div>
      </div>

      <div className="border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-border bg-secondary/40 label-mono text-muted-foreground text-left">
            <tr>
              <th className="p-3">User</th>
              <th className="p-3">Mobile</th>
              <th className="p-3">Role</th>
              <th className="p-3">Verified</th>
              <th className="p-3">Followers</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border font-mono">
            {loading ? (
              <tr><td colSpan={6} className="p-6 text-center text-muted-foreground">Loading…</td></tr>
            ) : users.map((u) => (
              <tr key={u.id} className="hover:bg-secondary/40" data-testid={`admin-user-row-${u.username}`}>
                <td className="p-3">
                  <div>@{u.username}</div>
                  <div className="text-muted-foreground text-xs">{u.full_name}</div>
                </td>
                <td className="p-3 text-muted-foreground">{u.mobile}</td>
                <td className="p-3">
                  <span className={`label-mono px-2 py-0.5 border ${u.role === "admin" ? "border-[hsl(var(--support))] text-[hsl(var(--support))]" : "border-border text-muted-foreground"}`}>
                    {u.role}
                  </span>
                </td>
                <td className="p-3">
                  {u.verification_status === "verified" ? <Check className="w-4 h-4 text-[hsl(var(--support))]" /> : <span className="text-muted-foreground">—</span>}
                </td>
                <td className="p-3 text-muted-foreground">{u.followers?.length || 0}</td>
                <td className="p-3">
                  <div className="flex gap-2">
                    <Button size="sm" variant="outline" className="rounded-sm h-8" onClick={() => suspend(u.id, u.suspended)} data-testid={`suspend-${u.username}`}>
                      {u.suspended ? <RotateCcw className="w-3 h-3" /> : <Ban className="w-3 h-3" />}
                    </Button>
                    <Button size="sm" variant="outline" className="rounded-sm h-8 hover:bg-[hsl(var(--oppose))] hover:text-white" onClick={() => del(u.id)} data-testid={`delete-user-${u.username}`}>
                      <Trash2 className="w-3 h-3" />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
